import React from "react"

import { StateResultsProvided } from "react-instantsearch-core"
import { connectStateResults } from "react-instantsearch-dom"

import { FormattedBody } from "~/components/ui"
import { RecipeAlgoliaHit } from "~/models/Recipe"
import { ResultState } from "~/templates/Category/types"

import css from "./HitCounter.module.scss"

type propType = StateResultsProvided & {
  resultState: ResultState<RecipeAlgoliaHit>
  hidden?: boolean
  setNbHits: (count: number) => void
}

const HitCounter = connectStateResults(
  ({ searchResults, resultState, setNbHits, hidden = false }: propType) => {
    //Use searchResults if not in SSG, else use resultState (baseResultState)
    const hitCount =
      searchResults && searchResults.nbHits > 0
        ? searchResults.nbHits
        : resultState && resultState.nbHits
        ? resultState.nbHits
        : 0

    //if we have a setHitsCount function, we use it to update the hits count state in the parent component
    setNbHits && setNbHits(hitCount)

    return hitCount > 0 && !hidden ? (
      <FormattedBody
        translationId="category/hit-counter/text:recipes-unit"
        translationValues={{
          count: hitCount,
        }}
        variant="body3"
        semiBold
        color="gray2"
        className={css.recipesNumber}
      />
    ) : null
  }
)

export default HitCounter
